import type { ActionsObservable } from 'redux-observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/jira-analytics-web-react/src/utils/fire-track-event.tsx';
import { toErrorId, toErrorMessage } from '@atlassian/jira-project-settings-apps-common/src/types';
import { logError } from '@atlassian/jira-project-settings-apps-common/src/util/error-logger';
import { PACKAGE_NAME } from '../../model/constants';
import type { Action } from '../../state/actions';
import { UPLOAD_AVATAR_SUCCESS } from '../../state/ui/actions';

const sendAnalytics = (analyticsEvent: UIAnalyticsEvent) => {
	try {
		fireTrackAnalytics(analyticsEvent, {
			action: 'uploaded',
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			tags: ['donut-world', 'project-details'] as string[],
			attributes: {
				simplified: true,
			},
		});
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		logError(
			PACKAGE_NAME,
			toErrorId('analytics.avatarUploaded'),
			toErrorMessage('Failed to send analytics event for project avatar uploaded'),
			error,
		);
	}
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>) =>
	action$
		.ofType(UPLOAD_AVATAR_SUCCESS)
		.do(({ meta }) => sendAnalytics(meta.analyticsEvent))
		.ignoreElements();
